goog.provide("shadow.js.shim.module$$mui$material$Dialog$default");
shadow.js.shim.module$$mui$material$Dialog$default = shadow.js.require(442, {})["default"];
